module.exports = __webpack_public_path__ + "img/house-of-hustle-bg.63dc709.jpg";